import { useToast as ChakraUseToast, UseToastOptions as ChakraUseToastOptions } from '@chakra-ui/react';

type DecoratedFuncType = (mergedOptions: ChakraUseToastOptions) => void;

const useToast = (options: ChakraUseToastOptions = {}): DecoratedFuncType => {
  const mergedOptions: ChakraUseToastOptions = {
    ...options,
    ...{
      position: 'bottom-left',
      status: 'success',
      variant: 'solid'
    }
  };
  return ChakraUseToast(mergedOptions);
};

export type UseToastOptions = ChakraUseToastOptions;
export default useToast;
